module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-up-+i.5a9a2388.svg";